import { Button, Dropdown, Menu, Form, InputNumber, message, Modal, Tooltip } from '@drip/drip-design';
import React, { useMemo, useState, useEffect } from 'react';
import './index.less';
import queryTree from '@/apis';
import { thousands } from '@/common/utils';
import Category from './catogory';
import NormalSelect from './normal-select';
import ComponentLog from '@/components/component-log';

const typeItems = {
  1: {
    name: '全部商品',
  },
  2: {
    id: 'goodsGroupId',
  },
  3: {
    id: 'brandId',
  },
  4: {
    id: 'categoryId',
  },
  5: {
    id: 'shopId',
  },
};

function SetPlan({ data, index, type, disabled, onSubmit, oneDelete, totalAmount }) {
  const { isNew, amount } = data;
  const [status, setStatus] = useState('view');

  useEffect(() => {
    setStatus('view');
  }, [data]);

  if (status === 'edit') {
    return <EditForm key={index} type={type} value={data} closeEdit={() => setStatus('view')} submit={onSubmit} />;
  }
  if (isNew) {
    return (
      <ComponentLog clstag="yx_center_hzcp_1678258944439|27">
        <Button
          type="primary"
          ghost
          className="product-plan-new-btn"
          onClick={() => setStatus('edit')}
          disabled={disabled}
        >
          + 新建计划
        </Button>
      </ComponentLog>
    );
  }
  if (status === 'view' && amount) {
    return (
      <ViewForm
        data={data}
        index={index}
        type={type}
        disabled={disabled}
        oneDelete={oneDelete}
        totalAmount={totalAmount}
        setStatus={setStatus}
      />
    );
  }

  return null;
}
function ViewForm({ data, index, type, disabled, oneDelete, totalAmount, setStatus }) {
  const { amount, name } = data;
  const menu = (
    <Menu>
      <Menu.Item onClick={() => setStatus('edit')} key={1}>
        修改
      </Menu.Item>
      <Menu.Item key={2} onClick={() => oneDelete(index)}>
        删除
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="product-plan-sub-info-block">
      <div className="product-plan-sub-info-header">
        <Tooltip title={type === 1 ? '全部商品' : name}>
          <span className="product-plan-sub-info-header-title ellipsis-1-line">{type === 1 ? '全部商品' : name}</span>
        </Tooltip>
        {disabled ? null : (
          <Dropdown overlay={menu}>
            <span className="product-plan-sub-info-header-menu">···</span>
          </Dropdown>
        )}
      </div>
      <div className="product-plan-sub-info-desc">
        <div className="self-amount">￥{thousands(amount)}</div>
        <div className="amount-rate">占总目标{Math.round((Number(amount) / totalAmount) * 100)}%</div>
      </div>
    </div>
  );
}

function EditForm({ value, type, closeEdit, submit }) {
  //"type": "1：全部商品，2：商品组，3：品牌，4：品类，5：店铺",
  const [form] = Form.useForm();
  const [categoryOption, setCategoryOption] = useState([]);

  useEffect(() => {
    if (!form) return;
    form.setFieldsValue(Object.assign({}, form.getFieldsValue(true), { info: undefined }));
  }, [type, form]);

  useEffect(() => {
    if (!value || !value.amount || !form) return;
    const { goodsGroupId, brandId, categoryId, shopId, amount, name } = value;
    const _value = {
      amount: Number(amount),
      info: {
        value: goodsGroupId || brandId || categoryId || shopId,
        label: name,
      },
    };
    form.setFieldsValue(_value);
  }, [value, form]);

  useEffect(() => {
    if (type == 4) {
      queryTree
        .statisticTree({ type: 3 }, 4, false)
        .then((res) => {
          const { ret, msg, data } = res;
          if (!data || ret !== '0') throw msg || '类目树获取失败';
          setCategoryOption(data);
        })
        .catch((ex) => {
          message.error(ex);
        });
    }
  }, [type]);

  const onFinish = (formVal) => {
    if (getSubPlanAmount() > formVal.amount) {
      Modal.confirm({
        title: '修改金额的大小，不能小于已拆分金额',
        centered: true,
      });
    } else {
      let _val = { amount: formVal.amount };
      if (type !== 1) {
        const { label, value } = formVal.info;
        _val.name = label;
        _val[typeItems[type].id] = value;
      }

      submit(_val);
      closeEdit();
    }
  };

  function getSubPlanAmount() {
    if (!value || !value.levelPlan) return 0;
    const sum = value.levelPlan.reduce((result, val) => {
      if (!val) return result;
      return result + Number(val.amount);
    }, 0);
    return sum;
  }

  const subPlanForm = {
    1: <AllSku />,
    2: <NormalSelect type={2} />,
    3: <NormalSelect type={3} />,
    4: <Category option={categoryOption} />,
    5: <NormalSelect type={5} />,
  };

  return (
    <Form form={form} onFinish={onFinish} className="product-plan-sub-edit-block">
      <div className="product-plan-sub-edit-block-form">
        {subPlanForm[type] ? (
          <Form.Item name="info" noStyle>
            {subPlanForm[type]}
          </Form.Item>
        ) : null}
        <Form.Item name="amount" noStyle>
          <InputNumber placeholder="目标成交金额" min={0} style={{ width: 128 }} />
        </Form.Item>
      </div>
      <Form.Item noStyle shouldUpdate={(prev, curr) => prev.info !== curr.info || prev.amount !== curr.amount}>
        {({ getFieldValue }) => {
          const info = getFieldValue('info');
          const amount = getFieldValue('amount');
          let disabled = type == 1 ? !amount : !(amount && info);
          return (
            <div className="product-plan-sub-edit-block-operate">
              <Button type="link" onClick={closeEdit} style={{ marginBottom: 10 }}>
                取消
              </Button>
              <Button type="link" htmlType="submit" disabled={disabled}>
                完成
              </Button>
            </div>
          );
        }}
      </Form.Item>
    </Form>
  );
}

function AllSku() {
  return <div style={{ lineHeight: '40px', marginLeft: '2px' }}>全部商品</div>;
}

export default SetPlan;
